export default __webpack_public_path__ + "static/media/logorealview.5b5cff67.png";